import $ from 'jquery';
import _ from 'lodash';

let isIEBrowser = window.navigator.userAgent.indexOf('MSIE ') >= 0 ||
	window.navigator.userAgent.indexOf('Trident') >= 0;

/*************************************************************************************************
 * public functions
 *************************************************************************************************/
const defaultExport = {
	checkInputType: function (type) {
		var input = document.createElement("input");
		input.setAttribute("type", type);
		return input.type === type;
	},
	/**
	 * @returns {string} RGB Color of HEX input - format: r,g,b
	 */
	hexToRgb: function (hex) {
		if (typeof hex === 'string') hex = hex.replace(/#/g, '');
		var bigint = parseInt(hex, 16);
		var r = (bigint >> 16) & 255;
		var g = (bigint >> 8) & 255;
		var b = bigint & 255;
		return r + "," + g + "," + b;
	},
	/**
	 * @param {String} string color to be tested for dynamic css generation
	 * @return {String | null} rgb color or null if invalid
	 */
	validateCssColor: function (string) {
		string = $.trim(string);
		var a = $("<div>", {css: {"background-color": "rgb(0,0,0)"}});
		var b = $("<div>", {css: {"background-color": "rgb(255,255,255)"}});
		a.css("background-color", string);
		b.css("background-color", string);
		var rgbaColor = a.css('background-color');
		return rgbaColor === b.css('background-color') ? rgbaColor : null;
	},
	isIEBrowser: function () {
		return isIEBrowser;
	},
	/**
	 * workaround for IE not applying transform changes correctly (as described in bug3061)
	 */
	fixIEfaSpin: function ($i) {
		if (this.isIEBrowser() && !$i.hasClass('fa-spin')) {
			$i.css({transform: 'none'});
			$i.css({transform: ''});
		}
	},
	positionTo: function (thatEl, toEl, options) {
		//set defaults:
		let params = _.assign({
			init: 'below', // over, below
			top: 0,
			left: 0,
			position: 'absolute',
		}, options);
		let $to = $(toEl);
		if (!$to[0]) $to = $('body');
		let $thatEl = $(thatEl);
		let currPos;
		switch (params.position) {
			case 'fixed':
				currPos = $to[0].getBoundingClientRect();
				break;
			default:
			case 'absolute':
				currPos = $to.offset();
				break;
		}
		let pos = _.pick(currPos, ['top', 'left']);
		switch (params.init) {
			case 'over':
				break;
			case 'above':
				pos.top = pos.top - $thatEl.outerHeight();
				break;
			case 'below':
			default:
				pos.top = pos.top + $to.outerHeight();
				break;
		}
		let width = $thatEl.outerWidth();
		let winW = $(document).innerWidth();
		if (params && params.top) pos.top = pos.top + params.top;
		if (params && params.left) pos.left = pos.left + params.left;
		if (winW < width + pos.left) {
			pos.left = Math.max(0, winW - width - 5);
		}
		if (pos.left < 0) {
			pos.left = 0;
		}
		pos.position = params.position;
		$thatEl.css(pos);
	},
	// end RETURN
};

export default defaultExport;